import {
  GroupedOptions,
  RegularOptions,
} from "@circle-react-shared/TextSelect";
import type { UseSearchableSelectProps } from "@circle-react-uikit/SearchableSelect";
import {
  SearchableSelectDropdown,
  filterByLabel,
  useSearchableSelect,
} from "@circle-react-uikit/SearchableSelect";
import { noop } from "lodash";

import { t } from "@/i18n-js/instance";

export interface TextSelectDropdownProps extends UseSearchableSelectProps<
  any,
  any
> {
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
  children?: React.ReactNode;
  emptyMessage?: string;
  groupBy?: UseSearchableSelectProps["groupByValue"];
  onSelect: UseSearchableSelectProps["onChange"];
  shouldRenderPortal?: boolean;
}

export const TextSelectDropdown = ({
  options = [],
  onSelect = noop,
  placeholder = t("select_an_option"),
  emptyMessage = t("no_options"),
  filterBy = filterByLabel,
  groupBy = undefined,
  displayValue = option => option?.label || "",
  children,
  buttonRef,
  optionsClassName,
  shouldRenderPortal = false,
}: TextSelectDropdownProps) => {
  const {
    dropdownProps,
    searchResults,
    hasNoResults,
    groupedSearchResults,
    hasGroups,
  } = useSearchableSelect<any, any>({
    options,
    onChange: onSelect,
    filterBy,
    placeholder,
    optionsClassName,
    displayValue,
    groupByValue: groupBy,
  });

  return (
    <SearchableSelectDropdown
      {...dropdownProps}
      buttonRef={buttonRef}
      button={children}
      shouldRenderPortal={shouldRenderPortal}
    >
      {hasNoResults && (
        <SearchableSelectDropdown.EmptyOption label={emptyMessage} />
      )}
      {!hasNoResults && !hasGroups && (
        <RegularOptions options={searchResults} />
      )}
      {!hasNoResults && hasGroups && (
        <GroupedOptions groupedOptions={groupedSearchResults} />
      )}
    </SearchableSelectDropdown>
  );
};
